/**
 * A4 landscape page format for the editor, the customer link and the PDF
 * (see sheetPagination).
 *
 * Re-exports dimensions from the canonical a4.ts source so there is a
 * single source of truth for all A4 calculations.
 */
import {
  A4_WIDTH_PX,
  A4_HEIGHT_PX,
  PAGE_PADDING_PX,
  PAGE_MAX_HEIGHT_PX,
} from './a4';

export const A4_LANDSCAPE = {
  width: A4_WIDTH_PX,
  height: A4_HEIGHT_PX,
  contentHeight: PAGE_MAX_HEIGHT_PX,
  padding: PAGE_PADDING_PX,
  pageGap: 24,
};
